// Minimap chip — top-right corner, driven by client-core's Minimap class
// (auto-zoomed terrain + tank dots; it self-sizes via its own ResizeObserver
// on the canvas, so all we do is toggle the CSS box). Tap anywhere on the
// chip to flip between the small chip (112px) and the enlarged view (208px).
//
// Note: Minimap.draw() is version-gated (skips when no snapshot arrived), so
// right after a size toggle the canvas may stay blank until the next
// snapshot lands — tens of milliseconds at the server's snapshot cadence,
// not worth defeating the gate for.

import { Minimap, type ClientState } from '@bolo2k/client-core';

export interface MinimapChip {
  readonly el: HTMLElement;
  /** Repaint from the latest state (no-op until the welcome arrives). */
  update(state: ClientState | null): void;
}

export function createMinimapChip(): MinimapChip {
  const el = document.createElement('div');
  el.className = 'm3k-chip m3k-minimap';
  const canvas = document.createElement('canvas');
  el.appendChild(canvas);

  const minimap = new Minimap(canvas);

  el.addEventListener('click', () => {
    el.classList.toggle('m3k-minimap--big');
    // Minimap's ResizeObserver picks up the new canvas box and rebuilds its
    // buffers; nothing else to do here.
  });

  return {
    el,
    update(state) {
      if (state) minimap.draw(state);
    },
  };
}
